module.exports = __webpack_public_path__ + "static/img/07.5768c007.png";